type Props = {
  className?: string;
};

const ParallaxSection: React.FC<Props> = ({ children, className }) => (
  <div className={`sec-parallax-section ${className || ""}`}>{children}</div>
);

export default ParallaxSection;
